import { useSnackbar } from 'notistack';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogProps,
  DialogTitle,
} from '@mui/material';

import { District } from '@/types';
import { useDeleteDistrictMutation } from '@/services';

export interface DeleteDistrictProps extends DialogProps {
  district: District;
  onClose(): void;
}

const DeleteDistrict: React.FC<DeleteDistrictProps> = ({ district, onClose, ...props }) => {
  const { enqueueSnackbar } = useSnackbar();

  const [deleteDistrict, deleteDistrictResponse] = useDeleteDistrictMutation();

  async function handleDeleteDistrict() {
    try {
      await deleteDistrict(district).unwrap();

      onClose();
    } catch (error) {
      enqueueSnackbar(error.data, { variant: 'error' });
    }
  }

  return (
    <Dialog fullWidth {...props}>
      <DialogTitle fontWeight="bold">{district?.name}</DialogTitle>

      <DialogContent dividers>
        <DialogContentText>Вы действительно хотите удалить "{district?.name}"?</DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button color="secondary" variant="outlined" disabled={deleteDistrictResponse.isLoading} onClick={onClose}>
          Закрыть
        </Button>

        <Button variant="contained" disabled={deleteDistrictResponse.isLoading} onClick={handleDeleteDistrict}>
          Да
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteDistrict;
